"use client";

import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import Image from "next/image";

interface LoaderProps {
    progress: number;
    isReady: boolean;
    onLoadingComplete?: () => void;
}

const Loader = ({ progress, isReady, onLoadingComplete }: LoaderProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const numberRef = useRef<HTMLHeadingElement>(null);
    const counterRef = useRef<{ value: number }>({ value: 0 });
    const [hasExited, setHasExited] = useState(false);

    useEffect(() => {
        if (!numberRef.current) return;
        gsap.to(counterRef.current, {
            value: progress,
            duration: 0.3,
            ease: "power2.out",
            onUpdate: () => {
                if (numberRef.current) {
                    numberRef.current.innerText = Math.round(counterRef.current.value).toString();
                }
            },
        });
    }, [progress]);

    useEffect(() => {
        if (!isReady || hasExited || !containerRef.current) return;
        setHasExited(true);

        gsap.to(containerRef.current, {
            yPercent: -100,
            duration: 1.2,
            ease: "power4.inOut",
            onComplete: () => {
                onLoadingComplete?.();
            },
        });
    }, [isReady, hasExited, onLoadingComplete]);

    return (
        <div
            ref={containerRef}
            className="fixed inset-0 z-[2000] flex items-center justify-center bg-[#D2170D] text-milk"
        >
            {/* Centered Logo Image */}
            <div className="fixed inset-0 flex items-center justify-center">
                <Image
                    src="/logo.jpeg"
                    alt="Kunafa Mafias Logo"
                    width={160}
                    height={160}
                    className="h-40 w-40 md:h-32 md:w-32 rounded-full object-contain"
                    priority
                />
            </div>

            {/* Bottom Left Counter - Smaller */}
            <h1
                ref={numberRef}
                className="absolute bottom-5 left-5 md:bottom-10 md:left-10 text-[8vw] md:text-[4vw] font-bold leading-none tracking-tighter"
            >
                0
            </h1>
        </div>
    );
};

export default Loader;
